let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jA7gz")).then(() => parcelRequire('4qzdE'));